<template>
  <div class="meal-list">
    <div class="meal-food-name"
      >{{ data.brand_name }} {{ data.package_name }}</div
    >
    <div
      class="meal-item"
      v-for="(mealItem, mealIndex) in data.food_list"
      :key="mealIndex"
    >
      <div class="meal-item-wrapper" @click="bindClick(mealItem)">
        <div class="meal-image super-food">
          <van-image
            class="meal-icon"
            lazy-load
            radius="8"
            fit="cover"
            :src="(mealItem.thumb_image_url || mealItem.icon) | filterUrl"
          />
          <img
            class="meal-flag"
            v-if="mealItem.is_super"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/159a9ada5ca72d0571bd0c2464441200.png"
            alt=""
          />
          <img
            class="meal-flag"
            v-else-if="mealItem.menu_type == 2"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f706aa97f0e404ecbfdd0da0c7ad1f3b.png"
            alt=""
          />
          <div class="product-icon" v-if="mealItem.product_logo">
            <img class="icon" :src="mealItem.product_logo" alt="" />
          </div>
        </div>
        <div class="meal-right">
          <div class="meal-r-top"
            ><span class="meal-name">{{ mealItem.name }}</span
            ><span class="meal-unit" v-if="mealItem.food_weight"
              >x{{ mealItem.food_weight | filterUnitNumber
              }}{{ mealItem.specs_name }}</span
            >
          </div>
          <div class="meal-type">{{
            mealItem.menu_type == 2
              ? mealItem.food_name_list
              : mealItem.attr_name
          }}</div>
        </div>
        <div
          class="buy-btn"
          v-if="mealItem.is_allow_takeaway"
          @click.stop="bindOrder(mealItem)"
          >点外卖</div
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    foodTypeList() {
      return (
        (this.$store.state.cnaV2.resultData &&
          this.$store.state.cnaV2.resultData.scienceFoodAttr) ||
        []
      )
    }
  },
  filters: {
    filterUnitNumber(num) {
      num = +num
      return num == 0.5 ? '半' : num
    },
    filterUrl(url) {
      if (url) {
        url = url + '?x-oss-process=image/resize,w_176/quality,Q_100'
      }
      return url
    }
  },
  methods: {
    bindOrder(item) {
      this.$emit('order', item)
    },
    bindClick(item) {
      this.$emit('into', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.meal-list {
  .meal-food-name {
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #60c3b2;
    line-height: 17px;
    margin-bottom: 6px;
  }

  .meal-item {
    background: #ffffff;
    border-radius: 6px;
    padding: 8px;
    margin-bottom: 8px;

    .meal-item-group,
    .meal-item-wrapper {
      display: flex;
      align-items: center;

      .meal-image {
        margin-right: 10px;
        position: relative;
        width: 44px;
        height: 44px;

        .meal-icon {
          border-radius: 6px;
          overflow: hidden;
          width: 44px;
          height: 44px;
          object-fit: contain;
        }

        .meal-flag {
          width: 44px;
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0%);
          bottom: 0;
          z-index: 2;
        }

        .product-icon {
          position: absolute;
          right: -5px;
          bottom: 0;
          width: 18px;
          height: 18px;
          border-radius: 6px;
          overflow: hidden;
          border: 1px solid #ffffff;
          box-sizing: border-box;
          z-index: 3;
          .icon {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }

      .meal-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;

        .meal-r-top {
          display: flex;
          align-items: center;

          .meal-name {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(0, 0, 0, 0.8);
            line-height: 20px;
          }

          .meal-unit {
            min-width: 30px;
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
          }
        }

        .meal-type {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 14px;
        }
      }

      .buy-btn {
        margin-left: 10px;
        height: 20px;
        border-radius: 12px;
        border: 1px solid #60c3b2;
        font-size: 10px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #60c3b2;
        line-height: 20px;
        padding: 0 6px;
      }

      .meal-unit {
        margin-left: 4px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 17px;
        color: rgba(0, 0, 0, 0.3);
      }
    }

    .meal-item-group {
      display: flex;
      align-items: center;

      .group-left {
        .group-item {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
        }

        .group-item:last-child {
          margin-bottom: 0;
        }
      }

      .group-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        display: flex;
        align-items: center;
        margin-left: 6px;

        .group-dash {
          border-radius: 0px 2px 2px 0px;
          box-sizing: border-box;
          width: 10px;
          height: 56px;
          border: 1px dashed rgba(0, 0, 0, 0.3);
          border-left: none;
          margin-right: 4px;
        }
      }
    }
  }

  .meal-item:last-child {
    margin-bottom: 0;
  }
}
</style>
